import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { TOOLBAR_UPLOAD_FILE } from '@editor/src/img/pageIndex';
import UploadFileTooltip from '@com/option-menu/upload-file-tooltip';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';
import { TDWActionType, TDWModuleType, TDWOperationType } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

export const config = {
    id: ActionType.UPLOAD_LOCAL_FILE,
    content: ENV.IS_PC_LOCAL_EDIT ? i18n.t('音视频文件') : i18n.t('本地文件'),
    icon: TOOLBAR_UPLOAD_FILE,
    twdConfig: {
        opername: TDWOperationType.DOC_WORD_EDITOR,
        module: TDWModuleType.LOCAL_FILES,
        action: TDWActionType.UPLOAD_CLICK,
        notReportVer5: true,
    },
};

export const INSERT_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
        tooltip: ENV.IS_PC_LOCAL_EDIT ? undefined : {
            content: <UploadFileTooltip />,
            alignment: 'start',
            placement: 'right',
        },
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];

export const TOOLBAR_ITEMS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: {
            content: <UploadFileTooltip />,
        },
        text: config.content,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
        respectOffline: !ENV.IS_PC_LOCAL_EDIT,
    },
];
